"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:OverlayLinksView");

/**
 * Affiche l'emplacement des entités
 * Trigger:
 * - "click:entity":
 */
module.exports = Backbone.View.extend({

    pageModel: null,
    className: "overlay overlay-links",
    hasPointerEvent: false,
    isHighlighted: false,

    events: {
        "pointerdown .link": "onPointerDown",
        "pointerup .link": "onPointerUp",
        "touchstart .link": "onPointerDown",
        "touchend .link": "onPointerUp"
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);

        T.hasPointerEvent = window.PointerEvent ? true : false;

        T.pointerPageX = 0;
        T.pointerPageY = 0;
        T.lastUp = 0;
        T.listenTo(T.pageModel, "sync", T.render);
        T.render();
    },

    render: function () {
        var T = this;

        T.$el.html("");
        if (T.pageModel.fetched) {
            debug("render links page " + T.page);
            var page_width = T.pageModel.get("width");
            var page_height = T.pageModel.get("height");
            var css;
            _.each(T.pageModel.get("links"), function (link) {
                var title;
                if (link.url.indexOf("page:") == 0) {
                    title = link.url.replace("page:", "p.");
                }
                else if (link.url.indexOf("modal://") == 0) {
                    title = link.url.replace("modal://", "");
                }
                else if (link.url.indexOf("video://") == 0) {
                    title = ""; // les éléments vidéo sont créé quand on affiche réellement la page, cf fonction highlight
                    css = "link-video";
                }
                else {
                    title = link.url;
                }

                var $div = $("<div/>", {
                    class: css || "link",
                    title: title
                }).data({
                    url: link.url
                });

                $div.css({
                    top: ((link.y / page_height) * 100) + "%",
                    left: ((link.x / page_width) * 100) + "%",
                    height: ((link.height / page_height) * 100) + "%",
                    width: ((link.width / page_width) * 100) + "%"
                });
                T.$el.append($div);

            });
            if (T.isHighlighted) {
                T.highlight();
            }
        }
    },

    onPointerDown: function (e) {
        var T = this;

        if (e.type == "touchstart" && T.hasPointerEvent) return; // ignore les events touch si le navigateur supporte les pointers events

        T.pointerPageX = e.pageX;
        T.pointerPageY = e.pageY;

        if (T.clickTimer) {
            clearTimeout(T.clickTimer);
            //debug("click clear timeout");
            T.clickTimer = null;
        }

    },

    onPointerUp: function (e) {
        var T = this;

        if (e.type == "touchend" && T.hasPointerEvent) return; // ignore les events touch si le navigateur supporte les pointers events

        var distance = Math.sqrt(Math.pow(T.pointerPageX - e.pageX, 2) + Math.pow(T.pointerPageY - e.pageY, 2));

        var now = Date.now();


        if (distance < 4 && now - T.lastUp > 500) {
            //debug("click set timeout");
            T.clickTimer = setTimeout(function () {
                debug("link clicked");
                T.trigger("click:link", T, $(e.target).data("url"));
            }, 500);
        }

        T.lastUp = now;
    },

    analyseUrl: function (url) {
        // youtube ?
        var final_url, type, video_id;

        var video_url = new URL(url);
        video_url.protocol = "https:";
        if (["youtu.be"].indexOf(video_url.hostname) != -1) {
            type = "youtube";
            video_id = video_url.pathname.split("/")[1];
            // youtu.be/aPCCzzVKO6w
            final_url = "https://www.youtube.com/embed/" + video_id + "?autoplay=1&mute=1";
        }
        else if (["www.youtube.com"].indexOf(video_url.hostname) != -1 && video_url.pathname.split("/")[1] == "watch") {
            type = "youtube";
            video_id = video_url.searchParams.get("v");
            // www.youtube.com/watch?v=3RK9eEc9rxQ
            final_url = "https://www.youtube.com/embed/" + video_id + "?autoplay=1&mute=1";
        }
        else if (["dai.ly"].indexOf(video_url.hostname) != -1) {
            type = "dailymotion";
            video_id = video_url.pathname.split("/")[1];
            // dai.ly/xw6eqt
            final_url = "https://www.dailymotion.com/embed/video/" + video_id + "?autoplay=1&mute=1";
        }
        else if (video_url.pathname.endsWith(".mp4")) {
            type = "video";
            final_url = video_url.href;
        }

        return {
            url: final_url,
            type: type
        };
    },

    constructVideo: function () {

        var T = this;

        var $videos = T.$(".link-video");

        $videos.each(
            function () {
                var $video_box = $(this);
                var url = $video_box.data("url")
                var result = T.analyseUrl(url);
                $video_box.html("");
                if (result.type == "video") {
                    var $video = $('<video controls="" autoplay muted name="media"><source src="' + result.url + '" type="video/mp4"></video>');
                    $video_box.append($video);
                }
                else if (result.type == "youtube" || result.type == "dailymotion") {
                    var $iframe = $('<iframe frameborder="0" src="' + result.url + '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
                    $video_box.append($iframe);
                }
            }
        )


    },

    deconstructVideo: function () {
        var T = this;
        var $videos = T.$(".link-video");
        $videos.each(
            function () {
                var $video_box = $(this);
                $video_box.html("");
            }
        )
    },

    highlight: function () {
        var T = this;
        T.$el.removeClass("hl");
        T.isHighlighted = true;
        setTimeout(function () { T.$el.addClass("hl"); }, 1);

        // construction des éléments vidéo en autoplay et muted ici
        T.constructVideo();
    },

    unhighlight: function () {
        this.isHighlighted = false;
        this.deconstructVideo();
    },

    close: function () {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/views/overlay-links-view.js
// module id = 46
// module chunks = 0